import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Login } from '../../components/';
import {
  login,
  authenticationTab,
  fetchUser,
  authenticationRequestFailure,
} from '../../store/actions/Authentication';
import {
  checkNewNotifications,
  getNotifications,
  setNotificationsThreadInterval,
} from '../../store/actions/Notification';
import { routesAction } from '../../shared/helpers';

const { hostname } = window.location;
const CHECK_NEW_NOTIFICATIONS_INTERVAL_TIME =
  hostname === 'localhost' ? 5000 : 15000;

class Authentication extends Component {
  constructor(props) {
    super(props);
    this.handlerLogin = this.handlerLogin.bind(this);
    this.handleUpdateActiveTab = this.handleUpdateActiveTab.bind(this);
  }

  componentDidMount() {
    const {
      location: { pathname },
      setActiveAuthenticationTab,
    } = this.props;

    if (pathname === '/login/editor') {
      setActiveAuthenticationTab(false);
    }
    this.checkNotifications();
  }

  handleUpdateActiveTab(event) {
    event.preventDefault();

    const activeTab = event.target.id === 'client';
    this.props.setActiveAuthenticationTab(activeTab);
  }

  handlerLogin({ email, password }, setSubmitting) {
    const {
      clientTabActive,
      dispatchLogin,
      dispatchFetchUser,
      dispatchAuthenticationRequestFailure,
    } = this.props;

    const userType = clientTabActive ? 'Client' : 'Freelancer';
    const data = { email, password, userType };
    dispatchLogin(data)
      .then(r => {
        if (r.payload.type === 'AUTHENTICATION_SUCCESS') {
          return dispatchFetchUser();
        }
        return null;
      })
      .then(action => {
        const { data: user } = action.payload;
        setSubmitting(false);
        const path =
          clientTabActive || user.current_step === 'dashboard'
            ? routesAction.default()
            : routesAction.freelancerOnboarding();
        this.props.history.push(path);

        this.checkNotifications();
      })
      .catch(() => {
        dispatchAuthenticationRequestFailure();
        setSubmitting(false);
      });
  }

  checkNotifications() {
    const {
      dispatchCheckNewNotifications,
      dispatchCheckNotificationsInterval,
    } = this.props;

    const interval = setInterval(
      dispatchCheckNewNotifications,
      CHECK_NEW_NOTIFICATIONS_INTERVAL_TIME,
    );

    dispatchCheckNotificationsInterval(interval);
  }

  render() {
    const { clientTabActive, isLogin, location } = this.props;

    return isLogin ? (
      <Redirect
        from="/login"
        to={location.state !== undefined ? location.state.from.pathname : '/'}
      />
    ) : (
      <Login
        onSubmit={this.handlerLogin}
        handleUpdateActiveTab={this.handleUpdateActiveTab}
        clientTabActive={clientTabActive}
      />
    );
  }
}

Authentication.propTypes = {
  clientTabActive: PropTypes.bool,
  isLogin: PropTypes.bool,
  setActiveAuthenticationTab: PropTypes.func,
  dispatchFetchUser: PropTypes.func,
  dispatchLogin: PropTypes.func,
  location: PropTypes.shape({
    state: PropTypes.shape({
      from: PropTypes.shape({
        pathname: PropTypes.string,
      }),
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  dispatchCheckNewNotifications: PropTypes.func,
  dispatchCheckNotificationsInterval: PropTypes.func,
  dispatchAuthenticationRequestFailure: PropTypes.func,
};

const mapStateToProps = state => ({
  clientTabActive: state.authentication.clientActiveTab,
  isFetching: state.authentication.isFetching,
  isLogin: state.authentication.isLogin,
  errors: state.authentication.errors,
  user: state.authentication.user,
});

const mapDispatchToProps = dispatch => ({
  dispatchLogin: data => dispatch(login(data)),
  setActiveAuthenticationTab: clientTabActive => {
    dispatch(authenticationTab(clientTabActive));
  },
  dispatchFetchUser: () => dispatch(fetchUser()),
  dispatchCheckNewNotifications: () => {
    dispatch(checkNewNotifications());
  },
  dispatchGetNotifications: () => dispatch(getNotifications()),
  dispatchAuthenticationRequestFailure: () =>
    dispatch(authenticationRequestFailure()),
  dispatchCheckNotificationsInterval: interval =>
    dispatch(setNotificationsThreadInterval(interval)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Authentication);



// WEBPACK FOOTER //
// ./src/containers/Authentication/Authentication.js